import {showModal, showTemporaryModal} from './modal';

function qs(sel) {
    return document.querySelector(sel);
}

function csrf() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
}

async function postJson(url, body) {
    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrf(),
        },
        body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.ok === false) throw new Error(data.error || data.message || `HTTP ${res.status}`);
    return data;
}

async function getJson(url) {
    const res = await fetch(url, {headers: {'Accept': 'application/json'}});
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.ok === false) throw new Error(data.error || `HTTP ${res.status}`);
    return data;
}

function renderSuggest(items) {
    const box = qs('#office-suggest');
    if (!items || items.length === 0) {
        box.classList.add('hidden');
        box.innerHTML = '';
        return;
    }
    box.innerHTML = items.map(it => `
    <button class="w-full text-left px-3 py-2 hover:bg-gray-50" data-pick="${it.e_number}">
      ${it.e_number}
    </button>
  `).join('');
    box.classList.remove('hidden');
}

function renderContent(rows) {
    const tbody = qs('#office-content-body');
    if (!rows || rows.length === 0) {
        tbody.innerHTML = `<tr><td class="py-3 text-gray-500" colspan="4">Keine Scans.</td></tr>`;
        return;
    }
    tbody.innerHTML = rows.map(r => `
    <tr class="border-b">
      <td class="py-2 pr-3">${r.ean}</td>
      <td class="py-2 pr-3">${r.name || ''}</td>
      <td class="py-2 pr-3 font-semibold">${r.qty}</td>
      <td class="py-2 pr-3 whitespace-nowrap">${r.last_scan}</td>
    </tr>
  `).join('');
}

function renderHistory(rows) {
    const tbody = qs('#office-history-body');
    if (!rows || rows.length === 0) {
        tbody.innerHTML = `<tr><td class="py-3 text-gray-500" colspan="4">Keine Historie.</td></tr>`;
        return;
    }
    tbody.innerHTML = rows.map(r => `
    <tr class="border-b">
      <td class="py-2 pr-3 whitespace-nowrap">${r.at}</td>
      <td class="py-2 pr-3">${r.ean}</td>
      <td class="py-2 pr-3">${r.name || ''}</td>
      <td class="py-2 pr-3 font-semibold">${r.qty_delta}</td>
    </tr>
  `).join('');
}

function renderLagerLeContent(rows, emptyMessage = 'Keine Scans.') {
    const tbody = qs('#office-lagerle-content-body');
    if (!tbody) return;

    if (!rows || rows.length === 0) {
        tbody.innerHTML = `<tr><td class="py-3 text-gray-500">${emptyMessage}</td></tr>`;
        return;
    }

    tbody.innerHTML = rows.map(eNumber => `
    <tr class="border-b">
      <td class="py-2 pr-3 font-semibold">${eNumber}</td>
    </tr>
  `).join('');
}

function initOffice() {
    if (!window.__OFFICE_ENDPOINTS__) return;

    const input = qs('#office-e-number');
    const suggest = qs('#office-suggest');
    const lagerle = qs('#office-lagerle');

    let eNumberTimer = null;
    let lagerLeTimer = null;

    input?.addEventListener('input', () => {
        const val = input.value.trim().toUpperCase();
        clearTimeout(eNumberTimer);
        if (val.length < 4) {
            renderSuggest([]);
            return;
        }

        const loadSuggestions = async () => {
            try {
                const url = new URL(window.__OFFICE_ENDPOINTS__.search, window.location.origin);
                url.searchParams.set('q', val);
                const data = await getJson(url.toString());
                renderSuggest(data.items || []);
            } catch (e) {
                renderSuggest([]);
            }
        };

        if (val.length === 6) {
            loadSuggestions();
            return;
        }

        eNumberTimer = setTimeout(loadSuggestions, 150);

    });

    lagerle?.addEventListener('input', () => {
        const val = lagerle.value.trim().toUpperCase();
        clearTimeout(lagerLeTimer);
        if (!val || val.length <= 4) {
            renderLagerLeContent([], 'Bitte P/R-Nummer scannen oder eingeben.');
            return;
        }

        lagerLeTimer = setTimeout(async () => {
            try {
                const url = new URL(window.__OFFICE_ENDPOINTS__.lagerLeContent, window.location.origin);
                url.searchParams.set('leident', val);
                const data = await getJson(url.toString());
                if (lagerle.value.trim().toUpperCase() === val) {
                    renderLagerLeContent(data.content || []);
                }
            } catch (e) {
                renderLagerLeContent([], 'Inhalt konnte nicht geladen werden.');
            }
        }, 150);

    });

    document.addEventListener('click', (ev) => {
        const btn = ev.target?.closest?.('[data-pick]');
        if (!btn) return;
        input.value = btn.getAttribute('data-pick');
        renderSuggest([]);
    });

    document.addEventListener('click', (ev) => {
        if (!suggest.contains(ev.target) && ev.target !== input) {
            renderSuggest([]);
        }
    });

    qs('#office-load')?.addEventListener('click', async () => {
        const en = input.value.trim().toUpperCase();
        if (!en) {
            showModal('Bitte E-Nummer eingeben.');
            return;
        }

        try {
            const url = new URL(window.__OFFICE_ENDPOINTS__.content, window.location.origin);
            url.searchParams.set('e_number', en);
            const data = await getJson(url.toString());
            renderContent(data.content || []);
            renderHistory(data.history || []);
        } catch (e) {
            showModal(e.message);
        }
    });

    qs('#office-assign')?.addEventListener('click', async () => {
        const en = input.value.trim().toUpperCase();
        const le = lagerle.value.trim().toUpperCase();
        if (!en) {
            showModal('Bitte E-Nummer eingeben.');
            return;
        }
        if (!le) {
            showModal('Bitte Ziel-Palette oder Ziel-Rolli eingeben.');
            return;
        }

        try {
            const data = await postJson(window.__OFFICE_ENDPOINTS__.assign, {
                e_number: en,
                leident: le,
            });
            const target = data.leident.startsWith('P')
                ? `die Ziel-Palette ${data.leident}`
                : `den Ziel-Rolli ${data.leident}`;
            showTemporaryModal(`Die E-Kistennummer ${data.e_number} wurde auf ${target} gelegt.`);
            lagerle.dispatchEvent(new Event('input', {bubbles: true}));
        } catch (e) {
            showModal(e.message);
        }
    });

    qs('#office-lagerle-abschliessen')?.addEventListener('click', async (event) => {
        const button = event.currentTarget;
        if (button.disabled) return;

        const en = input.value.trim().toUpperCase();
        const le = lagerle.value;
        if (!en) {
            showModal('Bitte E-Nummer eingeben.');
            return;
        }
        if (!le) {
            showModal('Bitte ZielPalette angeben.');
            return;
        }

        button.disabled = true;

        try {
            await postJson(window.__OFFICE_ENDPOINTS__.finishAndSubmitToLogbase, {
                e_number: en,
                leident: le
            });
            button.disabled = false;
            showModal('LagerLE ist nun in der Logbase gebucht. (E-Nummer verschwindet aus Autocomplete, weil zugeordnet)');
        } catch (e) {
            showModal(e.message);
        }
    });
}

document.addEventListener('DOMContentLoaded', initOffice);
